import { AllocationScenarioValuationModel } from 'api';
import { ValuationsApproach } from 'common/types/valuation';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { EquityAllocationCellCustomData } from 'pages/ValuationsAllocation/allocation/EquityAllocation/config';
import {
  OnChangeType,
  UpdateAllocationScenariosWithRelated,
} from 'pages/ValuationsAllocation/hooks/useEquityAllocationInputHandlers/types';
import { isVolatilityCell } from 'pages/ValuationsAllocation/util/cellValidators';

interface HandleVolatilityParams {
  cell: ICell<EquityAllocationCellCustomData>;
  allocationScenarios: AllocationScenarioValuationModel[];
  approaches: ValuationsApproach[];
  cells: any;
  onChange: OnChangeType;
  updateAllocationScenariosWithRelated: UpdateAllocationScenariosWithRelated;
}

/**
 * Handles changes to volatility cells in the equity allocation sheet.
 * Recalculates allocation scenarios when volatility or volatility source changes.
 */
export const handleVolatility = async (params: HandleVolatilityParams): Promise<void> => {
  const { cell, allocationScenarios, approaches, cells, onChange, updateAllocationScenariosWithRelated } = params;

  if (!isVolatilityCell(cell)) {
    return;
  }
  await updateAllocationScenariosWithRelated(
    {
      allocationScenarios,
      approaches,
    },
    cells,
    onChange
  );
};
